import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { SOURCE_TCAPI } from '@rsos/constants/locationSources';
import {
  useGetConversation,
  useHasConversationBeenInitiated,
  useIsConversationEnded,
} from '@rsos/reduxDataStore/src/features/conversations/utils';
import { useSelectedCallerID } from '@rsos/reduxDataStore/src/features/emergencyCalls';
import {
  setSelectedTab,
  setChatVisibility,
} from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import { CHAT_TAB } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneTabs';
import ConversationsChatHeader from '../../CallChats/ConversationsChatBox/ConversationsChatHeader';
import LiveChatCard from './LiveChatCard';

const ConversationsChatCard = () => {
  const dispatch = useDispatch();

  const selectedCallerID = useSelectedCallerID() || '';
  const hasConversationBeenInitiated =
    useHasConversationBeenInitiated(selectedCallerID);
  const isConversationEnded = useIsConversationEnded(selectedCallerID);
  const showLiveChat = hasConversationBeenInitiated && !isConversationEnded;

  const tcapiConversation = useGetConversation(selectedCallerID);

  const isTcapiClosed = useMemo(() => {
    if (
      !tcapiConversation ||
      tcapiConversation.source !== SOURCE_TCAPI ||
      !tcapiConversation.data
    ) {
      return false;
    }
    return (
      tcapiConversation.data.acceptStatus === 'timed_out' ||
      tcapiConversation.data.status === 'inactive'
    );
  }, [tcapiConversation]);

  const handleStartChat = () => {
    // Ensure the chat is expanded when navigating to Chat tab
    dispatch(
      setChatVisibility({
        chatType: 'isConversationsChatVisible',
        isVisible: true,
      }),
    );
    dispatch(setSelectedTab(CHAT_TAB));
  };

  return (
    <>
      {showLiveChat ? (
        <LiveChatCard
          onClick={handleStartChat}
          callerID={selectedCallerID}
          isTcapi={tcapiConversation?.source === SOURCE_TCAPI}
          isTcapiClosed={isTcapiClosed}
        />
      ) : (
        <ConversationsChatHeader
          isChatBoxVisible={false}
          isConversationStarted={hasConversationBeenInitiated}
          handleStartChat={handleStartChat}
          isForOverview
          isTcapiClosed={isTcapiClosed}
        />
      )}
    </>
  );
};

export default ConversationsChatCard;
